import { Component } from "@angular/core";
import { RouterModule } from "@angular/router";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-enterprise";

interface GeneralLinkCellRendererParams extends ICellRendererParams {
  labelFromData?: (params: boolean) => boolean;
  dataKey?: (params: string) => string;
  iconFunc?: (data: any) => string[] | string[];
  routerLink?: any[] | string;
  label?: string | string | number | undefined;
  icon?: string | string | undefined | string[] | string[];
  onClickFunc?: (data?: any) => void;
}

@Component({
  selector: "ag-grid-warehouse-link-renderer",
  imports: [RouterModule],
  template: `
    @if (routerLink != null) {
      <a class="bm-link bm-link-hover flex flex-row gap-1 items-center" [routerLink]="routerLink">
        @if (icon) {
          <i class="{{ icon }}"></i>
        }
        @if (label != null) {
          <span>{{ label }}</span>
        }
      </a>
    } @else {
      <a class="bm-link bm-link-hover flex flex-row gap-1 items-center" (click)="onClick()" href="javascript:;">
        @if (icon) {
          <i class="{{ icon }}"></i>
        }
        @if (label != null) {
          <span>{{ label }}</span>
        }
      </a>
    }
  `,
})
export class AgGridGenericLinkRenderer implements ICellRendererAngularComp {
  params!: ICellRendererParams;
  public label!: string | string | number | undefined;
  public routerLink!: any[] | string;
  public icon?: string | string | undefined | string[] | string[];
  public iconFunc?: (data: any) => string[] | string[];
  onClickFunc?: (data: any) => void;

  public onClick() {
    console.log();
    if (this.onClickFunc) {
      this.onClickFunc(this.params?.data);
    }
  }

  agInit(params: GeneralLinkCellRendererParams) {
    this.params = params;
    if (params.onClickFunc) {
      this.onClickFunc = params.onClickFunc;
    }
    if (params.icon && (params.icon !== "" || (params.icon || []).length > 0)) {
      this.icon = Array.isArray(params.icon) ? params.icon.join(" ") : params.icon;
    }
    if (params.iconFunc) {
      this.icon = params.iconFunc(params.data);
    }
    if (params.data && params.labelFromData) {
      this.label = params.data[`${params.dataKey}`];
    } else {
      this.label = params.label;
    }
    if (params.data && params.routerLink && Array.isArray(params.routerLink)) {
      this.routerLink = params.routerLink.map((link) => {
        if (`${link}`.startsWith("@")) {
          const key = `${link}`.replace("@", "");
          return params.data[key];
        }
        return link;
      });
    } else if (params.routerLink && !Array.isArray(params.routerLink)) {
      this.routerLink = params.routerLink;
    } else {
      this.routerLink = null;
    }
  }

  refresh(params: ICellRendererParams) {
    this.params = params;
    // As we have updated the params we return true to let AG Grid know we have handled the refresh.
    // So AG Grid will not recreate the cell renderer from scratch.
    return true;
  }
}
